'use client';

import { useSessionCartInfoTracking } from './useSessionCartInfoTracking';

export const SessionCartInfoTracking = () => {
  useSessionCartInfoTracking();

  return null;
};
